export const DEFAULT_LOCALE = 'ru';
export const DEFAULT_SOURCE_CURRENCY = 'usd';
export const DEFAULT_TARGET_CURRENCY = 'uah';
export const DEFAULT_CURRENCY_TYPE = 'money';
export const DEFAULT_CONVERTER_TYPE = 'midbank';
export const DEFAULT_VALUE = 100;
export const DEFAULT_PRIORITY = 0;
export const DEFAULT_API_DATE_FORMAT = 'DD-MM-YYYY';
export const DEFAULT_MOBILE_DATE_FORMAT = 'YYYY-MM-DD';
export const DEFAULT_TIMESTAMP_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const DEFAULT_CLIENT_DATE_FORMAT = 'YYYY-MM-DD HH:mm [UTC]';
export const DEFAULT_SEO_DATE_FORMAT = 'DD MMMM YYYY';
export const DEFAULT_CHART_DATE_FORMAT = 'D MMM';
export const YEAR_CHART_DATE_FORMAT = 'MMM YY';
export const TODAY_CHART_DATE_FORMAT = 'HH:mm';

export const TYPES_ENUM = {
  banks: 0,
  mb: 1,
  auction: 2,
  nbu: 3,
  0: 'banks',
  1: 'mb',
  2: 'auction',
  3: 'nbu',
};
